import React from 'react';

import Device from '@core/scripts/components/device';
import SeoFooter from './SeoFooter.jsx';
import SeoShopLinkCluster from './SeoShopLinkCluster.jsx';

export default function SeoContent({seoContent}) {
    const seoFooter = seoContent.seoFooter;

    if (Device.isApp()) {
        return <></>;
    }
    return (
        <div className="article-overview__info-content info-content__wrapper">
            {seoFooter && seoFooter.entriesAsString ? <SeoFooter seoFooter={seoFooter} /> : <></>}
            {seoContent.shopLinkSections ? (
                <SeoShopLinkCluster shopLinkClusters={seoContent.shopLinkSections} />
            ) : (
                <></>
            )}
        </div>
    );
}
